import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { GetApproversApi } from "../../api/approvals/GetApproversApi";
import { openNotificationError } from "../../helpers/NotificationHelpers";
import { getTargetString } from "../../helpers/targetHelpers";

const { Option } = Select;

function UpdateTargetProgressModal(props) {
  const positionState = useSelector((state) => state.positionState.value);
  const [approvers, setApprovers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [valuesChanged, setValuesChanged] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    getApprovers();
  }, []);

  function handleCancel() {
    setValuesChanged(false);
    props.handleCancel();
    form.resetFields();
  }

  async function getApprovers() {
    const apiResponse = await GetApproversApi(positionState?.id);

    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      setApprovers(apiResponse?.data);
      form.setFields([
        {
          name: "approver",
          value: apiResponse?.data[0]?.id || "",
        },
      ]);
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't edit approver. Try again later."
      );
    }
    setLoading(false);
  }

  return (
    <Modal
      title="Update Target Progress"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <>
        {loading ? (
          <div className="flex justify-center items-center h-20">
            <Spin />
          </div>
        ) : (
          <Form
            name="planGroup"
            onFinish={props.onFinish}
            autoComplete="off"
            layout="vertical"
            onValuesChange={() => {
              setValuesChanged(true);
            }}
            form={form}
            requiredMark={false}
          >
            <div className="flex items-center">
              <Form.Item
                label="Target Progress: "
                name="target"
                initialValue={props.targetProgress}
                rules={[
                  {
                    required: true,
                    message: "Please enter target!",
                  },
                ]}
              >
                <InputNumber />
              </Form.Item>
              <div className="mx-1 text-lg">/</div>
              <div className="text-lg">
                {getTargetString(
                  props.data?.target,
                  props.data?.scale?.scaleName,
                  props.data?.scale?.scaleUnitAbbreviation
                )}
              </div>
            </div>
            {(positionState?.userRole?.name === "Manager" ||
              positionState?.userRole?.name === "User") &&
              !!approvers?.length && (
                <Form.Item
                  label="Approver: "
                  name="approver"
                  rules={[
                    {
                      required:
                        (positionState?.userRole?.name === "Manager" ||
                          positionState?.userRole?.name === "User") &&
                        !!approvers?.length &&
                        true,
                      message: "Please select approver!",
                    },
                  ]}
                >
                  <Select
                    allowClear
                    showSearch
                    placeholder="Select approver"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                  >
                    {approvers?.map((approver) => {
                      return (
                        <Option key={approver?.id} value={approver?.id}>
                          {(approver?.designations?.abbreviation ||
                            approver?.designations?.name) +
                            "," +
                            approver?.units?.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              )}

            <Form.Item style={{ marginBottom: 0 }}>
              <div className=" flex justify-end">
                <Button className="mr-3 w-28" onClick={() => handleCancel()}>
                  Cancel
                </Button>
                <Button
                  className="btn w-28"
                  type="primary"
                  htmlType={props.submit && "submit"}
                  disabled={props.submit || !valuesChanged}
                >
                  {props.submit ? (
                    <Spin
                      size="small"
                      indicator={
                        <LoadingOutlined style={{ color: "#fff" }} spin />
                      }
                    />
                  ) : (
                    "Save"
                  )}
                </Button>
              </div>
            </Form.Item>
          </Form>
        )}
      </>
    </Modal>
  );
}
export default UpdateTargetProgressModal;
